// Panther Resource Bundles
export const CHECKOUT_BUNDLE_NAME = 'pages.checkout';
export const HOMEPAGE_MESSAGE_BUNDLE_NAME = 'pages.homepage';
export const PRODUCT_DETAILS_PAGE_BUNDLE_NAME = 'pages.productdetails';
export const COMMON_BUNDLE_NAME = 'common';
export const INTAKE_FORM_PAGE_BUNDLE_NAME = 'pages.intakeForm';
export const MY_ACCOUNT_PAGE_BUNDLE_NAME = 'pages.myAccount';
export const BILLING_INFORMATION_PAGE_BUNDLE_NAME = 'pages.billingAddressInformationForm';
export const COMMON_FORM_STRINGS = 'pages.commonFormStrings';
export const BUYER_CRITERIA_BUNDLE_NAME = 'pages.buyerCriteria';
export const SEGMENT_PAGE_BUNDLE_NAME = 'pages.segmentpage';
export const REDUCE_DEFORESTATION_BUNDLE_NAME = 'pages.reducedeforestation';
export const SUPERPOLLUTANTS_BUNDLE_NAME = 'pages.superpollutants';
export const TECH_CARBON_REMOVAL_BUNDLE_NAME = 'pages.techcarbonremoval';
export const RESTORING_FORESTS_BUNDLE_NAME = 'pages.restoringforests';
export const LOWER_CARBON_FUELS_BUNDLE_NAME = 'pages.lowercarbonfuels';
export const STORE_PAGE_BUNDLE_NAME = 'pages.storepage';
